"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BasicError = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
class BasicError extends Error {
  /**
   * @constructor
   */
  constructor(message, error, data, name) {
    super(error && error.message ? `${message} <- ${error.message}` : message);
    if (error) {
      if (_lodash.default.isError(error)) this.cause = () => error;else data = error;
    }
    if (data) _lodash.default.merge(this, _lodash.default.isObject(data) ? data : {
      data
    });
    this.name = name || _lodash.default.get(this, ['__proto__', 'constructor', 'name']) || 'Error';
  }
  get fullStack() {
    let stack = this.stack;
    try {
      let cause = this.cause;
      while (_lodash.default.isFunction(cause)) {
        const error = cause();
        if (!error) break;
        stack = `${stack}\n...caused by ${error.stack ? error.stack : JSON.stringify(error)}`;
        cause = error.cause;
      }
    } catch (error) {
      stack = `${stack}\n\n...full stack failed ${error.stack}`;
    }
    return stack;
  }
}
exports.BasicError = BasicError;
var _default = BasicError;
exports.default = _default;